import { Component, Inject } from '@angular/core';
import { ThemeService } from '../../../services/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignatureDocumentsService } from '../../../services/signatureDocuments.service';
import { interval, switchMap, takeWhile } from 'rxjs';

export interface DialogDataConfirmationDialogSignature {
  message: string;
  canOk: boolean;
  canCancel: boolean;
  messageOk: string;
  messageCancel: string;
  html: boolean;
  icon: boolean;
  dataIcon: string;
  idSignature: number;
}
@Component({
  selector: 'app-confirmation-dialog-signature',
  templateUrl: './confirmation-dialog-signature.component.html',
  styleUrl: './confirmation-dialog-signature.component.scss',
  standalone: false
})
export class ConfirmationDialogSignatureComponent {
  
 isProcessing: boolean;
 showSync: boolean;
 showCheck: boolean;
 fadeOut: boolean;

 constructor(
    private signatureDocumentsService: SignatureDocumentsService,
    private themeService: ThemeService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ConfirmationDialogSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmationDialogSignature) { }

  ngOnInit(): void {
    this.isProcessing = true;
    this.showSync = true;
    this.showCheck = false;
    this.fadeOut = false;
    this.data.canOk = this.data.canOk != null ? this.data.canOk : true;
    this.data.canCancel = this.data.canCancel != null ? this.data.canCancel : true;
    this.data.message = this.translate.instant('notification.signer.signedDocumentEnd.message');

    interval(9000)
    .pipe(
      switchMap(() => this.signatureDocumentsService.existsFinishedByIdDocumentAndIdType(this.data.idSignature)),
      takeWhile(result => !result, true)
    )
    .subscribe({
      next: (result: boolean) => {
        if (result) {
          this.data.message = this.translate.instant('notification.signer.signedDocumentFinished.message');
          this.data.canOk = true;
          this.isProcessing = false;
          this.fadeOut = true;

          setTimeout(() => {
            this.showSync = false;
            this.showCheck = true;
          }, 600);
        }
      }
    });
      
  }

  onOkClick(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }
}

